/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Live_Updates_UnavailableInputs */



/**
* | output |
* | --- |
* | "Live updates are not active — changes in the source appear only after a manual sync." |
*
* @param {Sync_Degraded_Live_Updates_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_live_updates_unavailable = /** @type {((inputs?: Sync_Degraded_Live_Updates_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Live_Updates_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Aktualisierung ist nicht aktiv — Änderungen in der Quelle erscheinen erst nach einer manuellen Synchronisierung.")
	return /** @type {LocalizedString} */ ("Live updates are not active — changes in the source appear only after a manual sync.")
});